var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTapemeasure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.25 12.25H15.25C15.3826 12.25 15.5098 12.3027 15.6036 12.3964C15.6973 12.4902 15.75 12.6174 15.75 12.75V14.5",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.49894 14.25H12.9989V11.75L11.3527 10.915C11.8336 10.2057 12.1369 9.39111 12.2371 8.54C12.4558 6.69625 11.7133 4.83313 10.4058 3.70188L10.0733 2.51438C9.2401 1.97809 8.29334 1.64342 7.3082 1.53693C6.32306 1.43043 5.32665 1.55505 4.39808 1.90088C3.46951 2.24671 2.63433 2.80424 1.95886 3.52921C1.28338 4.25417 0.786194 5.12662 0.506771 6.07728C0.227347 7.02795 0.173378 8.03067 0.349146 9.00584C0.524914 9.981 0.925581 10.9018 1.51934 11.6951C2.1131 12.4883 2.88361 13.1323 3.76969 13.5758C4.65578 14.0193 5.63305 14.2501 6.62394 14.25",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2652 10.5C13.7645 9.19076 13.8802 7.76628 13.5987 6.39362C13.3172 5.02095 12.6502 3.757 11.6758 2.75",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6348 3.98047L14.3991 5.00547C14.6261 5.13746 14.792 5.3534 14.8611 5.60668C14.9302 5.85996 14.897 6.13026 14.7685 6.35922L13.7423 8.18797",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.75 6H6L5.78937 7.47312C5.99104 7.33356 6.2293 7.2564 6.4745 7.25125C6.7197 7.2461 6.96099 7.3132 7.16833 7.44418C7.37568 7.57517 7.53991 7.76425 7.64057 7.98789C7.74124 8.21153 7.7739 8.45984 7.73448 8.7019C7.69505 8.94396 7.5853 9.16908 7.41887 9.34922C7.25245 9.52936 7.03671 9.65656 6.79852 9.71498C6.56033 9.77341 6.31022 9.76048 6.07932 9.6778C5.84843 9.59512 5.64696 9.44634 5.5 9.25",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.00026 4.3561C5.83714 3.96959 6.78439 3.89408 7.67193 4.14313C8.55947 4.39218 9.32915 4.94948 9.84277 5.71495C10.3564 6.48042 10.5803 7.40392 10.4743 8.31962C10.3683 9.23533 9.93933 10.0832 9.26441 10.7111C8.58949 11.339 7.71285 11.7057 6.79188 11.7454C5.87092 11.7851 4.96597 11.4952 4.23953 10.9277C3.51309 10.3603 3.01274 9.55239 2.82833 8.6492C2.64393 7.74602 2.78754 6.80667 3.23339 5.99985",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTapemeasure);
export default __webpack_public_path__ + "static/media/tape measure.f9153b5a.svg";
export { ForwardRef as ReactComponent };